import { emailRegex } from "./constants";

export const isEmailValid = (email: string) =>
  !!email && email.search(emailRegex) !== -1;

export const getEmailError = (email: string) =>
  (isEmailValid(email) ? null : "Введите e-mail в формате maria@mail.ru");
